import { render, staticRenderFns } from "./EmailVerificationSignupStep.vue?vue&type=template&id=ace615c2&"
import script from "./EmailVerificationSignupStep.vue?vue&type=script&lang=ts&"
export * from "./EmailVerificationSignupStep.vue?vue&type=script&lang=ts&"
import style0 from "./EmailVerificationSignupStep.vue?vue&type=style&index=0&id=ace615c2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ace615c2')) {
      api.createRecord('ace615c2', component.options)
    } else {
      api.reload('ace615c2', component.options)
    }
    module.hot.accept("./EmailVerificationSignupStep.vue?vue&type=template&id=ace615c2&", function () {
      api.rerender('ace615c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/guest/gsx/signupSteps/EmailVerificationSignupStep.vue"
export default component.exports